import styled from '@emotion/styled';

import { Link, useNavigate } from 'react-router-dom';

import { Grid, Card, CardHeader, CardContent, IconButton, Button } from '@mui/material';

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from '../../../utils/utilities/CardComponents';

import MultiStatusChip from '../../../utils/utilities/MultiStatusChip';

import SimpleChip from '../../../utils/utilities/SimpleChip';

import { relativeTime, formatPhoneNumber, formatGenericDateTime, formatGenericDate } from '../../../utils/util';

import { BasicFlex } from '../../../utils/Common';


import LocalOfferRoundedIcon from '@mui/icons-material/LocalOfferRounded';
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import ConfirmationNumberRoundedIcon from '@mui/icons-material/ConfirmationNumberRounded';
import PhoneAndroidRoundedIcon from '@mui/icons-material/PhoneAndroidRounded';
import EditOutlined from '@mui/icons-material/EditOutlined';
import ContentPasteSearchRoundedIcon from '@mui/icons-material/ContentPasteSearchRounded';

import { useQuery } from '@tanstack/react-query';

import { getInvoiceById } from '../../Invoices/apiService';

// use pageData context
import { usePageData } from '../../../contexts/PageData';

import InvoiceDisplay from '../../../components/Invoices/Components/InvoiceDisplay';


const InvoiceTab = () => {
  const { data = {} } = usePageData();

  let invoice_id = data?.invoice_id || data?.wo_invoice_id;

  const { data: invoice = {} } = useQuery({
    queryKey: ['invoices', invoice_id],
    queryFn: () => getInvoiceById(invoice_id),
    enabled: !!invoice_id
  })

  console.log(invoice, "invoice", invoice_id);

  let customer = invoice?.customer || {};

  const customerBlock = [
    {header: "Customer", icon: <AccountBoxOutlinedIcon fontSize='small' />, info: customer.full_name},
    {header: "Phone", icon: <PhoneAndroidRoundedIcon fontSize='small' />, info: formatPhoneNumber(customer.mobile_phone)},
  ]

  const basicBlock = [
    {header: "Invoice ID", icon: <ConfirmationNumberRoundedIcon fontSize='small' color="basic" />, info: `#${invoice?.invoice_num}`},
    {header: "Date", info: relativeTime(invoice.date)},
    {header: "Sales Rep", info: invoice.sales_rep},
  ]

  const invoiceBlock = [
    {header: "Invoice Total",  info: invoice.total, dataType: "currency"},
    {header: "Paid Status", info: <MultiStatusChip value={invoice.paid_status} values={[{value: "unpaid", label: "Unpaid", status: "error"}, {value: "partially_paid", label: "Partially Paid", status: "warning"}, {value: "paid", label: "Paid", status: "success"}]} />},
    {header: "Paid Amount", info: invoice.total_paid, dataType: "currency"},
    {header: "Balance", info: invoice.balance, dataType: "currency"},
  ]

  return (
    <Grid container spacing={3}>

      <Grid size={{xs: 12, md: 4}}>
        <Card variant='outlined'>
          <CardHeader title="Invoice Summary" action={<BasicFlex><Link to={`/invoices/edit/${invoice_id}`}><IconButton color="secondary"><EditOutlined /></IconButton></Link><Link to={`/invoices/view/${invoice_id}`}><IconButton color="tertiary"><ContentPasteSearchRoundedIcon /></IconButton></Link></BasicFlex>} />
          <CardContent>
            <CardBlockContainer>
              {customerBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}

              <CardSpacer />
              <CardBlockHeader>General Details</CardBlockHeader>
              {basicBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}

              <CardSpacer />
              <CardBlockHeader>Invoice Details</CardBlockHeader>
              {invoiceBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}
              <CardSpacer />
            </CardBlockContainer>
          </CardContent>
        </Card>
      </Grid>

      <Grid size={{xs: 12, md: 8}}>
        <InvoiceDisplay invoice={invoice} />
      </Grid>


    </Grid>
  );

};

export default InvoiceTab;